import MultiSelectField from './MultiSelectField';

export default MultiSelectField;
